import React, { PureComponent } from 'react';
import { string, bool, any, func } from 'prop-types';
import { WithLoading } from '@widergy/energy-ui';

import { terminationRequestSteps } from 'redux/customProceduresHandlers';

import AccountSelection from './components/AccountSelection';
import TerminationRequestData from './components/TerminationRequestData';
import TerminationRequestDetails from './components/TerminationRequestDetails';

const mapRouteToStepComponent = {
  [terminationRequestSteps.AccountSelection]: AccountSelection,
  [terminationRequestSteps.TerminationRequestData]: TerminationRequestData,
  [terminationRequestSteps.TerminationRequestDetails]: TerminationRequestDetails
};

const childProps = {
  [terminationRequestSteps.AccountSelection]: props => ({
    onSubmit: props.handleSubmitFirsStep,
    loading: props.loading,
    accountsData: props.accountsData.filter(account => account.cancel_service_enabled)
  }),
  [terminationRequestSteps.TerminationRequestData]: props => ({
    loading: props.loading,
    accountsData: props.accountsData,
    onTerminationCancel: props.onCancelRequest,
    onTerminationSuccess: props.onSubmitRequest,
    tempClientNumber: props.tempClientNumber,
    billList: props.billList ? props.billList.Recibos : []
  }),
  [terminationRequestSteps.TerminationRequestDetails]: props => ({
    loading: props.loading,
    accountsData: props.accountsData,
    customProcedureData: props.customProcedureData,
    invalid: props.invalid,
    accountTotalDebt: props.accountTotalDebt,
    accountDueDebt: props.accountDueDebt,
    billList: props.billList ? props.billList.Recibos : []
  })
};

class TerminationRequest extends PureComponent {
  render() {
    if (!this.props.accountsData) {
      return null;
    }
    const StepComponent = mapRouteToStepComponent[this.props.currentStep];
    const stepProps = childProps[this.props.currentStep](this.props);
    return <StepComponent {...stepProps} />;
  }
}

TerminationRequest.propTypes = {
  accountsData: any, // eslint-disable-line
  handleSubmitFirsStep: func.isRequired,
  loading: bool,
  currentStep: string,
  onCancelRequest: func.isRequired,
  onSubmitRequest: func.isRequired,
  tempClientNumber: string,
  billList: any, // eslint-disable-line
  customProcedureData: any // eslint-disable-line
};

export default WithLoading(props => props.loading)(TerminationRequest);
